// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-host-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
    animation: confirm-host-fade-in 0.15s ease-out;
}

@keyframes confirm-host-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

.confirm-host-modal {
    background: #ffffff;
    border-radius: 12px;
    max-width: 440px;
    width: 100%;
    padding: 1.5rem;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
    animation: confirm-host-slide-up 0.2s ease-out;
}

@keyframes confirm-host-slide-up {
    from { transform: translateY(8px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}

.confirm-host-title {
    margin: 0 0 0.5rem;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
}

.confirm-host-message {
    margin: 0 0 1.25rem;
    font-size: 0.95rem;
    line-height: 1.5;
    color: #334155;
    white-space: pre-wrap;
    word-break: break-word;
}

.confirm-host-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
}

.confirm-host-btn {
    padding: 0.55rem 1.1rem;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.15s;
}

.confirm-host-btn-cancel {
    background: #f1f5f9;
    color: #334155;
}

.confirm-host-btn-cancel:hover {
    background: #e2e8f0;
}

.confirm-host-btn-primary {
    background: #4f46e5;
    color: #ffffff;
}

.confirm-host-btn-primary:hover {
    background: #4338ca;
}

.confirm-host-btn-danger {
    background: #dc2626;
    color: #ffffff;
}

.confirm-host-btn-danger:hover {
    background: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmHost.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,OAAO,0BAA0B,EAAE,UAAU,EAAE;IAC/C,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC/C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".confirm-host-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.55);\n    backdrop-filter: blur(2px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n    padding: 1rem;\n    animation: confirm-host-fade-in 0.15s ease-out;\n}\n\n@keyframes confirm-host-fade-in {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n.confirm-host-modal {\n    background: #ffffff;\n    border-radius: 12px;\n    max-width: 440px;\n    width: 100%;\n    padding: 1.5rem;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n    animation: confirm-host-slide-up 0.2s ease-out;\n}\n\n@keyframes confirm-host-slide-up {\n    from { transform: translateY(8px); opacity: 0; }\n    to { transform: translateY(0); opacity: 1; }\n}\n\n.confirm-host-title {\n    margin: 0 0 0.5rem;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.confirm-host-message {\n    margin: 0 0 1.25rem;\n    font-size: 0.95rem;\n    line-height: 1.5;\n    color: #334155;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.confirm-host-actions {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: flex-end;\n}\n\n.confirm-host-btn {\n    padding: 0.55rem 1.1rem;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.15s;\n}\n\n.confirm-host-btn-cancel {\n    background: #f1f5f9;\n    color: #334155;\n}\n\n.confirm-host-btn-cancel:hover {\n    background: #e2e8f0;\n}\n\n.confirm-host-btn-primary {\n    background: #4f46e5;\n    color: #ffffff;\n}\n\n.confirm-host-btn-primary:hover {\n    background: #4338ca;\n}\n\n.confirm-host-btn-danger {\n    background: #dc2626;\n    color: #ffffff;\n}\n\n.confirm-host-btn-danger:hover {\n    background: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
